
export class utilities {

    static readonly DEFAULT_GUID = "00000000-0000-0000-0000-000000000000";

    static generateGUID(): string {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
            const random = Math.random() * 16 | 0; // Random number between 0 and 15
            const value = char === "x" ? random : (random & 0x3) | 0x8; // For 'y', ensure the variant bits are set correctly
            return value.toString(16); // Convert to hexadecimal
        });
    }

    static getUserId = (): string => {
        const userId = localStorage.getItem("userId");
        return userId ? userId : "";
    }
}